/* istanbul ignore file */
import React from 'react';
import { UpdateBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import SingleVacancyPublicationBreadcrumbs from 'domain/recruiting/vacancy/publication/shared/SingleVacancyPublicationBreadcrumbs';

const UpdateVacancyPublicationBreadcrumbs = () => {
  return (
    <SingleVacancyPublicationBreadcrumbs>
      <UpdateBreadcrumbItem />
    </SingleVacancyPublicationBreadcrumbs>
  );
};

export default UpdateVacancyPublicationBreadcrumbs;
